import type { AddEditClinicianRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * Lotus Health office address and contact info submitted for every prescriber.
 * These fields are not user-editable — the onboarding form hides them and
 * injects these values at submission time.
 */
export const LOTUS_OFFICE_DEFAULTS = {
  Address1: '535 Mission St',
  City: 'San Francisco',
  State: 'CA',
  ZipCode: '94105',
  PrimaryPhone: '6282121990',
  PrimaryFax: '4153585998',
} as const satisfies Partial<AddEditClinicianRequestT>;
